module.exports = __webpack_public_path__ + "static/media/handFlexedRight.9784cbda.png";